module.exports = __webpack_public_path__ + "static/media/19-6.deb947e7.mp3";